import './Unidades.css';
import unidades from '../../../core/unidades';
import { Link } from 'react-router-dom';

const Unidades = () => {

    return (
        <>
            <section id='services' name='services'>
                <div class="container text-center">
                    <h2 class="title">Nossas Unidades &#x1F94B;</h2>
                    <div className="row text-center">
                        {unidades.map(unidade => {
                            return (
                                <div className="col-md services" data-aos="fade-up" data-aos-delay="300" key={unidade.nome}>
                                    <Link to={{ pathname: `/unidade/${unidade.shortname}` }}>
                                        <div>
                                            <img src={unidade.foto} alt="" class="service-img" />
                                            <h4>{unidade.nome}</h4>
                                            <button className="btn-primary">Detalhes</button>
                                        </div>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>


                </div>
            </section>
        </>
    )

};

export default Unidades;
